import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IonContent, ModalController} from '@ionic/angular';
import {GalleryComponent} from '../../../../../components/gallery-component/gallery-component';
import {LocalStorageService, UserService} from '../../../../../_services';
import {environment} from '../../../../../../environments/environment';
import {ToastService} from '../../../../../_services/toast.service';
import {PreviewImageComponent} from '../../../../../components/preview-image/preview-image.component';
import {LoadingService} from '../../../../../_services/loading.service';
import {PreviewReportComponent} from '../../../../../components/preview-report/preview-report.component';
import {CommonService} from '../../../../../_services/common.service';
import {EmotionReportProvider} from '../../../../../_services/emotion-report';
import {DeleteReportComponent} from '../../../../../components/delete-report/delete-report.component';

@Component({
  selector: 'app-why-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss'],
})
export class ReportDetailsComponent implements OnInit {

  /*@Input() report: any;*/
  @Input() eventType: any;
  @Input() addDeleteOption: boolean;
  @ViewChild(IonContent) content: IonContent;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEvent: EventEmitter<any> = new EventEmitter<any>();
  report: any;
  reportDetails: { emotions?: any; images?: any; reports?: any; popularity?: any; site?: any; event?: any } = {};
  serverUrl = environment.server + '/public';
  shared = false;
  reportImages = [];
  selectedProjectObj: any;
  selectedReportId: any;
  public project = {
    type: 'ic',
    logo: '/assets/img/logo/LOGO-IC.svg',
    name: 'INVISIBLECITY'
  };

  constructor(public router: Router,
              private toast: ToastService,
              private activatedRoute: ActivatedRoute,
              private spinner: LoadingService,
              private localStorage: LocalStorageService,
              private commonService: CommonService,
              private emotionService: EmotionReportProvider,
              private userService: UserService,
              public modalController: ModalController) {
    this.selectedProjectObj = this.localStorage.get('selected_project');
  }

  @Input() set reportObj(value) {
    this.report = value;
    this.groupReports();
    this.reportDetails = {};
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: any) => {
      if (params.title) {
        this.report.title = params.title;
        this.report.address = params.address;
        this.shared = params.shared;
      }
    });
    // this.groupReports();
  }

  dismiss(): void {
    this.closeEvent.emit();
  }

  gotToTop() {
    this.content.scrollToTop(400);
  }

  addReport() {
    this.dismiss();
    const projectType = this.localStorage.get('projectType');
    if (projectType === 'ap') {
      this.toast.error('Please select project');
    } else {
      this.report.projectType = this.report.hasOwnProperty('projectType') ? this.report.projectType : projectType;
      this.router.navigate(['./survey'], {queryParams: this.report});
    }
  }

  shareEmotion() {
    const projectType = this.localStorage.get('projectType');
    // eslint-disable-next-line max-len
    const content = environment.server + '/map?lat=' + this.report.location[1] + '&lng=' + this.report.location[0] + '&projectType=' + projectType;
    navigator.clipboard.writeText(content).then(() => {
      /* clipboard successfully set */
      this.toast.display('Link copied successfully');
    }, (error) => {
      this.toast.error('Failed to fetch link');
    });
  }

  groupReports() {
    if (this.eventType !== 'newReport' && this.report.title) {
      this.spinner.show();
      const title = this.report.title === undefined ? this.report.name : this.report.title;
      const location = this.report.location;
      this.userService.groupReports(title, this.report.address, location, this.report.projectType)
        .subscribe((data) => {
          this.reportDetails.images = [];
          this.reportImages = [];
          if (data.reports.length !== 0) {
            this.reportDetails = data;
            this.reportDetails.images.forEach((obj: any) => {
              if (obj !== '') {
                this.reportImages.push(obj);
              }
            });
          } else {
            this.reportDetails.site = data.site;
            this.reportDetails.event = data.event;
            if (this.report.type !== 'site' && this.report.type !== 'event') {
              this.reportDetails.reports = [];
              this.reportDetails.images = [];
              this.reportDetails.reports.push(this.report);
              this.reportDetails.images.push(this.report.image);
              this.reportDetails.images.forEach((obj: any) => {
                if (obj !== '') {
                  this.reportImages.push(obj);
                }
              });
            }
          }
          this.localStorage.set('report_details', this.reportDetails);
          this.spinner.hide();
        }, (error) => {
          console.error(error);
          this.spinner.hide();
        });
    }
  }

  async navigateToGallery() {
    const modal = await this.modalController.create({
      component: GalleryComponent,
      componentProps: {
        reportDetails: this.reportDetails
      },
      cssClass: 'custom-modal to-left',
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  viewReport(reportObj) {
    this.dismiss();
    this.router.navigate(['./add-report'], {queryParams: reportObj});
  }

  async previewImage(image) {
    const modal = await this.modalController.create({
      component: PreviewImageComponent,
      componentProps: {
        image
      },
      cssClass: 'custom-modal to-left',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  async openPreview(obj: any) {
    const modal: any = await this.modalController.create({
      component: PreviewReportComponent,
      componentProps: {
        obj
      },
      cssClass: 'custom-modal to-left',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  addSite() {
    console.log(this.report.location);
    this.router.navigate(['/add-site'], {
      queryParams: {
        title: this.report.title,
        lat: this.report?.location[1],
        lng: this.report?.location[0]
      }
    });
  }

  deleteReport(id) {
    event.stopPropagation();
    this.spinner.show();
    this.emotionService.deleteReport(id)
      .subscribe((data) => {
        this.spinner.hide();
        this.toast.display('Report deleted successfully');
        this.deleteEvent.emit();
      }, (error) => {
        this.spinner.hide();
        this.toast.error('Failed to delete report');
      });
  }

  async openConfirm(reportId: any) {
    const selectedReportId = reportId;
    const modal = await this.modalController.create({
      component: DeleteReportComponent,
      cssClass: 'pop-up-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });
    modal.onDidDismiss()
      .then((value) => {
        if (value.data === 'delete') {
          this.deleteReport(selectedReportId);
        }
      });
    return await modal.present();
  }
}
